import ISymbolTypeGameConfig from '../../vendor_core/core/src/managers/contracts/configurations/game/ISymbolTypeGameConfig';
import AbstractVendorGameGeneralConfig from '../../vendor_core/src/vendorConfigs/AbstractVendorGameGeneralConfig';

class GameGeneralConfig extends AbstractVendorGameGeneralConfig {
    minWinAnimTime: number;
    symbolType: ISymbolTypeGameConfig = {
        spine: true,
        standard: false,
        symbol3D: false
    };
    gameType: 'cascade' | 'normal' = 'cascade';
    minWatchTime = 1;
    maxWinCapMultiplier?: number = 10000;
}

export default new GameGeneralConfig()
